import * as thermalMath from '../../utils/thermal-math';

import { getItemByNid, getValue } from '../../utils/calculations-helper';

import { buildUIStringArray, getCalculation, getSection } from '../../utils/index';

import { CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_CALCULATE_RESULTS, updateResults } from '../../modules/calculation';


export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const {
      claddings,
      energy,
      environments,
      materials,
      mediums,
      products,
      project,
      settings,
      app,
      adapters,
      translations,
    } = store.getState();

    const ui = buildUIStringArray(app.language, translations.data);

    switch (type) {
      case CALCULATION_CALCULATE_RESULTS:
        const c = getCalculation(project);
        const sCompare = getSection(c);

        if(sCompare.type === CALCULATION_TYPE_CIRCULAR_DUCT || sCompare.type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
//          console.log('Pipe')
          // calculate
          next(action);
          // let t0 = performance.now();

          const o = {};
          o.sectionResults = [];

          let contentTemperature;
          let uninsulatedContentTemperature;
          let totalPipelineHeatLoss = 0;
          let totalUninsulatedPipelineHeatLoss = 0;
          let totalAdaptersHeatloss = 0;
          let finalPipelineTemperature;

          for(let i = 0; i < c.sections.length; i++)  {
            const s = c.sections[i];

            if(i === 0) {
              uninsulatedContentTemperature = getValue(s.temperature, 'float');
              contentTemperature = getValue(s.temperature, 'float');
            }

            let material = getItemByNid(s.material, materials);
            let content = getItemByNid(s.content, mediums);
            let energySource = getItemByNid(c.energyType, energy);
            let environment = getItemByNid(s.environmentType, environments);
            let cladding = getItemByNid(s.cladding, claddings);

// CIRCULAR DUCT
            if(s.type === CALCULATION_TYPE_CIRCULAR_DUCT) {
              let layers = [];
              let maxTemperatures = [];
              let layerProducts = [];
              let nominalDensity = [];
              let lambdas = [ [ getValue(material['Thermal-conductivity'], 'float') ]];
              let innerDiameters = [ getValue(s.outerDiameter, 'mmToMeters') - 2 * getValue(s.thickness, 'mmToMeters') ];
              let outerDiameters = [ getValue(s.outerDiameter, 'mmToMeters') ];
              let innerDiameter = getValue(s.outerDiameter, 'mmToMeters');
              let outerDiameter = getValue(s.outerDiameter, 'mmToMeters');

              let contentFlowRate = thermalMath.unitConversion(s.flowRate, c.flowRateType, 'pipe', getValue(s.outerDiameter, 'mmToMeters'), 0, 0, getValue(content['Density'], 'int'), getValue(s.thickness, 'mmToMeters'));

              let contentLambda = getValue(content['Thermal-conductivity'], 'float');
              let contentVisc = getValue(content['Kinematic-viscosity'], 'float');
              let contentDensity = getValue(content['Density'], 'float');
              let contentHeatCapasity = getValue(content['Heat-capasity'], 'float');

              let insThickness = 0;
              s.insulationLayers.forEach(ins => {
                insThickness += getValue( parseInt(ins.selectedThickness), 'mmToMeters');
              });

              const targetDef = {
                type: 'duct',
                model: 'circular',
                actualType: c.type,
                direction: s.direction,
                diameter: (getValue(s.outerDiameter, 'mmToMeters') + 2 * insThickness),
                insideDiameter: ( getValue(s.outerDiameter, 'mmToMeters') - 2 * getValue(s.thickness, 'mmToMeters') ),
                length: parseFloat(s.length),
                flowRate: parseFloat(contentFlowRate),
                lambda: contentLambda,
                viscosity: contentVisc,
                density: contentDensity,
                heatCapasity: contentHeatCapasity,
                content: content.Medium,
                insideTemp: contentTemperature,
                claddingSupport: s.supportOfCladding,
                claddingSupportInfluence: getValue(s.influenceOnHeatloss, 'float'),
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.emissivity, 'float'),
              };

              for(let j = 0; j < s.insulationLayers.length; j++) {
                layers.push(getItemByNid(s.insulationLayers[s.insulationLayers.length - j - 1].selectedItem, products));
                lambdas.push([getValue(layers[j].a, 'float'), getValue(layers[j].b, 'float'), getValue(layers[j].c, 'float'), getValue(layers[j].d, 'float')]);

                maxTemperatures.push({mst: getValue(layers[j].MST, 'int'), facing: getValue(layers[j]['Facing-MST'], 'int'), net: getValue(layers[j]['Net-MST'], 'int')});

                outerDiameter = innerDiameter + 2 * getValue(s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness, 'mmToMeters');
                innerDiameters.push(innerDiameter);
                outerDiameters.push(outerDiameter);
                innerDiameter = outerDiameter;

                nominalDensity.push(getValue(layers[j]['nominal-density'], 'float'));
                if(layers[j].hasOwnProperty('custom') && layers[j].custom === 'true') {
                  layerProducts.push({name: '*' + layers[j]['name'], thickness: s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness});
                  if(layers[j]['name'].indexOf('Section') !== -1) {
                    targetDef.isSection = true;
                  }
                } else {
                  layerProducts.push({name: layers[j]['Product-name'], thickness: s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness});
                  if(layers[j]['Product-name'].indexOf('Section') !== -1) {
                    targetDef.isSection = true;
                  }
                }
              }

  //      var resultArr2:Array = thermalMath.heatlossIterative( "pipe", pipeMaterial.emissivity, contentTemperature, sectionEnvironment.temperature, [pipeMaterial.thermalConductivity], sectionEnvironment.velocity, [], [section.outerDiameterInMetric - section.thicknessInMetric * 2], [section.outerDiameterInMetric], true);
  //      var resultArr3:Array = thermalMath.heatlossIterative( "pipe", pipeMaterial.emissivity, contentTemperatureUnI, sectionEnvironment.temperature, [pipeMaterial.thermalConductivity], sectionEnvironment.velocity, [], [section.outerDiameterInMetric - section.thicknessInMetric * 2], [section.outerDiameterInMetric], true);


              let uninsulatedHeatLossResults = thermalMath.heatLossIterative('pipe', getValue(material.Emissivity, 'float'),
                                      contentTemperature, getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
                                      getValue(s.environmentAirVelocity, 'float'), [0], [getValue(s.outerDiameter, 'mmToMeters') - getValue(s.thickness, 'mmToMeters') * 2], [getValue(s.outerDiameter, 'mmToMeters')], true, {...targetDef, uninsulated: true});

              let heatLossResults;
              if(s.noInsulation) {
                heatLossResults = uninsulatedHeatLossResults;
              } else {
                heatLossResults = thermalMath.heatLossIterative('pipe', getValue(s.emissivity, 'float'),
                                    contentTemperature, getValue(s.environmentTemperature, 'float'),  lambdas,
                                    getValue(s.environmentAirVelocity, 'float'), [0], innerDiameters, outerDiameters, false, targetDef);
              }
/*
              let uninsulatedPipelineHeatLoss = thermalMath.heatLossIterative('pipe', getValue(material.Emissivity,'float'),
                                      uninsulatedContentTemperature, getValue(s.environmentTemperature,'float'),  [ getValue(material['Thermal-conductivity'],'float') ],
                                      getValue(s.environmentAirVelocity,'float'), [0], [getValue(s.outerDiameter,'mmToMeters') - getValue(s.thickness,'mmToMeters')],[getValue(s.outerDiameter,'mmToMeters')], true);
 */

              let addToHeatLoss = 0;
              let addToHeatLossUnins = 0;
              if(s.supportOfCladding) {
                addToHeatLoss += getValue(s.influenceOnHeatloss, 'float');
              }
              if(s.suspensionOfTarget) {
                addToHeatLoss += getValue(s.suspensionInfluence, 'float');
                addToHeatLossUnins += getValue(s.suspensionInfluence, 'float');
              }

              // Calculate the heat loss and the temperature drop in sections
              var sliceEndTempIns;
              var sliceEndTempUnIns;
              let sliceFactor = 0.1;
              if(s.length >= 10000) {
                sliceFactor = 10;
              } else if(s.length >= 1000) {
                sliceFactor = 1;
              }
              if(c.calculateTemperatureChange && parseFloat(s.length) > 0 && parseFloat(contentFlowRate) > 0 ) {
                let sliceCount = s.length / sliceFactor;
                let sliceTempIns = contentTemperature;
                let sliceTempUnIns = contentTemperature;
                let sliceHeatlossIns, sliceHeatlossUnIns;
                let originalHeatloss = heatLossResults[2];
                let originalHeatlossUnInsulated = uninsulatedHeatLossResults[2];
                for(let slice = 0; slice < sliceCount; slice++) {
                  sliceHeatlossUnIns = thermalMath.heatLossIterative('pipe', getValue(material.Emissivity, 'float'),
                                                sliceTempUnIns, getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
                                                getValue(s.environmentAirVelocity, 'float'), [0], [getValue(s.outerDiameter, 'mmToMeters') - getValue(s.thickness, 'mmToMeters') * 2],
                                                [getValue(s.outerDiameter, 'mmToMeters')], true, {...targetDef, noLog: true});
                  sliceHeatlossIns = thermalMath.heatLossIterative('pipe', getValue(s.emissivity, 'float'),
                                                sliceTempIns, getValue(s.environmentTemperature, 'float'),  lambdas,
                                                getValue(s.environmentAirVelocity, 'float'), [0], innerDiameters, outerDiameters, false, {...targetDef, noLog: true});
                  if(s.noInsulation) {
                    sliceHeatlossIns = sliceHeatlossUnIns;
                  }

                  let sliceTempDropIns;
                  // let sliceTempDropUnIns;
                  if(s.supportOfCladding || s.suspensionOfTarget) {
                    sliceTempDropIns = thermalMath.temperatureDrop( getValue(s.outerDiameter, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(sliceFactor, 'float'),  sliceTempIns,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  (sliceHeatlossIns[2] + (sliceHeatlossIns[2] * addToHeatLoss) / 100 ), getValue(s.thickness, 'mmToMeters'));
                  } else {
                    sliceTempDropIns = thermalMath.temperatureDrop( getValue(s.outerDiameter, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(sliceFactor, 'float'),  sliceTempIns,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  sliceHeatlossIns[2], getValue(s.thickness, 'mmToMeters'));
                  }
                  // if(s.suspensionOfTarget) {
                  //   sliceTempDropUnIns = thermalMath.temperatureDrop( getValue(s.outerDiameter,'mmToMeters'),  contentFlowRate,  getValue(content.Density,'float'),  getValue(0.1,'float'),  sliceTempUnIns,  getValue(s.environmentTemperature,'float'),  getValue(content['Heat-capasity'],'float'),  (sliceHeatlossUnIns[2] + (sliceHeatlossUnIns[2]*addToHeatLoss)/100), getValue(s.thickness,'mmToMeters'));
                  // } else {
                  const sliceTempDropUnIns = thermalMath.temperatureDrop( getValue(s.outerDiameter, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(sliceFactor, 'float'),  sliceTempUnIns,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  sliceHeatlossUnIns[2], getValue(s.thickness, 'mmToMeters'));
                  // }
                  sliceTempIns = sliceTempDropIns;
                  if(s.noInsulation) {
                    sliceTempIns = sliceTempDropUnIns;
                  }

                  sliceTempUnIns = sliceTempDropUnIns;
                }

                heatLossResults[2] = (originalHeatloss + sliceHeatlossIns[2]) / 2;
                uninsulatedHeatLossResults[2] = (originalHeatlossUnInsulated + sliceHeatlossUnIns[2]) / 2;
                sliceEndTempIns = sliceTempIns;
                sliceEndTempUnIns = sliceTempUnIns;
  //              console.log( {contentTemperature,endTemperature:sliceTemp,temperatureDrop:(sliceTemp-contentTemperature), heatLossStart:heatLossResults[2], heatLossEnd:sliceHeatloss[2]})
              }

                                      // TESTING temperaturedrop calculation in short sections
/*               let sliceCount = s.length/0.1;
              let sliceTemp= contentTemperature;
              let sliceHeatloss;
              for(let slice=0;slice<sliceCount;slice++) {
                if(s.noInsulation) {
                  sliceHeatloss = thermalMath.heatLossIterative('pipe', getValue(material.Emissivity,'float'),
                                              sliceTemp, getValue(s.environmentTemperature,'float'),  [ getValue(material['Thermal-conductivity'],'float') ],
                                              getValue(s.environmentAirVelocity,'float'), [0], [getValue(s.outerDiameter,'mmToMeters') - getValue(s.thickness,'mmToMeters')*2],
                                              [getValue(s.outerDiameter,'mmToMeters')], true);
                } else {
                  sliceHeatloss = thermalMath.heatLossIterative('pipe', getValue(s.emissivity,'float'),
                                              sliceTemp, getValue(s.environmentTemperature,'float'),  lambdas,
                                              getValue(s.environmentAirVelocity,'float'), [0], innerDiameters,outerDiameters, false);
                }
                let sliceTempDrop = thermalMath.temperatureDrop( getValue(s.outerDiameter,'mmToMeters'),  contentFlowRate,  getValue(content.Density,'float'),  getValue(0.1,'float'),  sliceTemp,  getValue(s.environmentTemperature,'float'),  getValue(content['Heat-capasity'],'float'),  sliceHeatloss[2], getValue(s.thickness,'mmToMeters'));
                sliceTemp=sliceTempDrop
              }
              console.log( {contentTemperature,endTemperature:sliceTemp,temperatureDrop:(sliceTemp-contentTemperature), heatLossStart:heatLossResults[2], heatLossEnd:sliceHeatloss[2]}) */

              let adapterResults = [];
              let adapterResultsTotal = 0;
              if(s.calculateAdapters) {
                // for(let a = 0; a < s.adapters.length; a++) {
                for(const adapter of s.adapters) {
                  // let adapter = s.adapters[a];
                  let aMaterial = getItemByNid(adapter.Material, materials);

                  let uninsulatedAdapterHeatlossResults = thermalMath.heatLossIterative('pipe', getValue(aMaterial.Emissivity, 'float'),
                                    contentTemperature, getValue(s.environmentTemperature, 'float'),  [ getValue(aMaterial['Thermal-conductivity'], 'float') ],
                                    getValue(s.environmentAirVelocity, 'float'), [0], [getValue(s.outerDiameter, 'mmToMeters') - getValue(adapter['Material-thickness'], 'mmToMeters') * 2],
                                    [getValue(s.outerDiameter, 'mmToMeters')], true, {...targetDef, noLog: true});

                  if(getValue(adapter.insCoverage, 'float') > 0) {
                    let aInsulation = getItemByNid('10', products);
                     // Adapter insulation is always PAROC Pro Wired Mat 100, Nid = 10
                    let aLambdas = [];
                    aLambdas.push([ getValue(aMaterial['Thermal-conductivity'], 'float') ]);
                    aLambdas.push( [ getValue(aInsulation.a, 'float'), getValue(aInsulation.b, 'float'), getValue(aInsulation.c, 'float'), getValue(aInsulation.d, 'float') ] );
                    let aInnerDiameters = [ ( getValue(s.outerDiameter, 'mmToMeters') - 2 * getValue(adapter['Material-thickness'], 'mmToMeters') ), getValue(s.outerDiameter, 'mmToMeters')];
                    let aOuterDiameters = [getValue(s.outerDiameter, 'mmToMeters'), (getValue(s.outerDiameter, 'mmToMeters') + 2 * getValue(adapter.insThickness, 'mmToMeters') ) ];

                    let adapterHeatlossResults = thermalMath.heatLossIterative('pipe', getValue(adapter.Emissivity, 'float'),
                                        contentTemperature, getValue(s.environmentTemperature, 'float'),  aLambdas,
                                        getValue(s.environmentAirVelocity, 'float'), [0], aInnerDiameters, aOuterDiameters, false, {...targetDef, noLog: true});

                    let adapterHeatloss = uninsulatedAdapterHeatlossResults[2] - (uninsulatedAdapterHeatlossResults[2] - adapterHeatlossResults[2]) * getValue(adapter.insCoverage, 'float') / 100;
                    adapterResults.push( (adapterHeatloss * adapter.Equivalence) );
                    adapterResultsTotal += (adapterHeatloss * adapter.Equivalence);
                  } else {
                    adapterResults.push( (uninsulatedAdapterHeatlossResults[2] * adapter.Equivalence) );
                    adapterResultsTotal += (uninsulatedAdapterHeatlossResults[2] * adapter.Equivalence) * adapter.count;
                  }
                }
              }

              o.sectionResults.push({heatloss: heatLossResults[2], alphae: heatLossResults[1]});
              o.sectionResults[i].surfaceTemperature = heatLossResults[3][ heatLossResults[3].length - 1 ];
              // o.sectionResults[i].uninsulatedHeatLoss = uninsulatedHeatLossResults[2] + ( uninsulatedHeatLossResults[2] * addToHeatLossUnins ) / 100;
              o.sectionResults[i].uninsulatedHeatLoss = uninsulatedHeatLossResults[2];
              o.sectionResults[i].uninsulatedHeatLossArea = thermalMath.heatlossConvertLengthToArea(o.sectionResults[i].uninsulatedHeatLoss, outerDiameters[0], 0, 0);

              if(s.calculateAdapters) {
                o.sectionResults[i].adapterHeatloss =  adapterResults;
                o.sectionResults[i].adapterHeatlossTotal = adapterResultsTotal;
                totalAdaptersHeatloss += adapterResultsTotal;
              }

              o.sectionResults[i].uninsulatedSurfaceTemperature = uninsulatedHeatLossResults[3][0];
              o.sectionResults[i].dewPoint = thermalMath.dewPoint(getValue(s.environmentTemperature, 'float'), getValue(s.environmentHumidity, 'float'));

              o.sectionResults[i].material = (material.hasOwnProperty('custom') && material.custom) ? material.name : material; // (material[app.language]!==false)?material[app.language]:material['English'];
              o.sectionResults[i].energySource = (energySource.hasOwnProperty('custom') && energySource.custom) ? energySource.name : energySource; // (energySource[app.language]!==false)?energySource[app.language]:energySource['English'];
              o.sectionResults[i].content = (content.hasOwnProperty('custom') && material.custom) ? content.name : content; // (content[app.language]!==false)?content[app.language]:content['English'];
              o.sectionResults[i].alphaR = heatLossResults[4][0];
              o.sectionResults[i].alphaK = heatLossResults[4][1];
              o.sectionResults[i].hSi = heatLossResults[4][2];
              o.sectionResults[i].addition = heatLossResults[4][3];
              o.sectionResults[i].joint = heatLossResults[4][4];

              if(s.cladding == -1) {
                o.sectionResults[i].cladding = ui['GENERAL-OTHER_CLADDING'];
              } else if(s.cladding == -2) {
                o.sectionResults[i].cladding = ui['GENERAL-NO_CLADDING'];
              } else if(cladding && cladding.hasOwnProperty('custom') && cladding.custom) {
                o.sectionResults[i].cladding = cladding.name;
              } else {
                o.sectionResults[i].cladding = cladding; // (cladding[app.language]!==false)?cladding[app.language]:cladding['English'];
              }

              o.sectionResults[i].nominalWeight = thermalMath.calculateInsulationWeight('pipe', innerDiameters, outerDiameters, 1, 0, 0, 0, nominalDensity);

              o.sectionResults[i].layers = [];
              for(let j = 0; j < layers.length; j++) {
                o.sectionResults[i].layers.push( { 'surfaceTemperature': heatLossResults[3][j + 1], 'thermalConductivity': heatLossResults[0][j + 1] } );
                o.sectionResults[i].layers[j].warnings = [];
                o.sectionResults[i].layers[j].product = layerProducts[j];

                if(maxTemperatures[j].mst <= heatLossResults[3][j]) {
                  o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-MATERIAL_MST_ALERT']);
                }
                if(maxTemperatures[j].facing <= heatLossResults[3][j + 1] && maxTemperatures[j].facing !== NaN) {
                  o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-FACING_MST_ALERT']);
                }
                if(maxTemperatures[j].net <= heatLossResults[3][j + 1] && maxTemperatures[j].net !== NaN) {
                  o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-NET_MST_ALERT']);
                }
              }

              if(s.noInsulation) {
                // o.sectionResults[i].heatloss = o.sectionResults[i].heatloss + ( o.sectionResults[i].heatloss * addToHeatLossUnins ) / 100;
                o.sectionResults[i].heatloss = o.sectionResults[i].heatloss;
                o.sectionResults[i].heatlossArea = thermalMath.heatlossConvertLengthToArea(o.sectionResults[i].heatloss, outerDiameters[0], 0, 0);
              } else {
                o.sectionResults[i].heatloss = o.sectionResults[i].heatloss + ( o.sectionResults[i].heatloss * addToHeatLoss ) / 100;
                o.sectionResults[i].heatlossArea = thermalMath.heatlossConvertLengthToArea(o.sectionResults[i].heatloss, outerDiameters[outerDiameters.length - 1], 0, 0);
              }

              o.sectionResults[i].coEmissionReduction = Math.abs( getValue(  (thermalMath.emissionCO2('pipe', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, uninsulatedHeatLossResults[2], 0, 0, getValue(s.length, 'float')) - thermalMath.emissionCO2('pipe', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, o.sectionResults[i].heatloss, 0, 0, getValue(s.length, 'float')) ), 'gToKg') );
              o.sectionResults[i].annualSavingsKwh = Math.abs( getValue( (thermalMath.annualCostKwh('pipe', uninsulatedHeatLossResults[2], c.energyOperationTime, 0, 0, s.length) - thermalMath.annualCostKwh('pipe', heatLossResults[2], c.energyOperationTime, 0, 0, s.length) ), 'wToKwh') );
              o.sectionResults[i].annualSavings = Math.abs( getValue( (thermalMath.annualCost('pipe', uninsulatedHeatLossResults[2], c.energyPrice, c.energyOperationTime, 0, 0, s.length) - thermalMath.annualCost('pipe', heatLossResults[2], c.energyPrice, c.energyOperationTime, 0, 0, s.length) ), 'cToE') );

              let temperatureAtTheSectionEnd;
              let uninsulatedTemperatureAtTheSectionEnd;
              if(c.calculateTemperatureChange) {
                temperatureAtTheSectionEnd = sliceEndTempIns;
                uninsulatedTemperatureAtTheSectionEnd = sliceEndTempUnIns;
              } else {
                temperatureAtTheSectionEnd = thermalMath.temperatureDrop( getValue(s.outerDiameter, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(s.length, 'float'),  contentTemperature,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  o.sectionResults[i].heatloss, getValue(s.thickness, 'mmToMeters'));
                uninsulatedTemperatureAtTheSectionEnd = thermalMath.temperatureDrop( getValue(s.outerDiameter, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),   getValue(s.length, 'float'),  uninsulatedContentTemperature,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  uninsulatedHeatLossResults[2], getValue(s.thickness, 'mmToMeters'));
              }

              o.sectionResults[i].temperatureDrop = temperatureAtTheSectionEnd - contentTemperature;
              o.sectionResults[i].coolingTime = '-';
              o.sectionResults[i].totalSectionHeatloss = o.sectionResults[i].heatloss * getValue(s.length, 'float');
              contentTemperature = temperatureAtTheSectionEnd;
              uninsulatedContentTemperature = uninsulatedTemperatureAtTheSectionEnd;
              totalPipelineHeatLoss += o.sectionResults[i].heatloss * getValue(s.length, 'float');
              totalUninsulatedPipelineHeatLoss += uninsulatedHeatLossResults[2] * getValue(s.length, 'float');

              if(app.country === 'Denmark' || app.country === 'Sweden' || (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) {
                  // calculateUValues(targetType, heatLoss, mediumTemp, outsideTemp, pipeDiameter, rectDuctWidth, rectDuctHeight, klasse:Object)
                let uKlasse;
                let pipeDef = parseFloat(settings['global-pipe-diameter-definition']);
                if(app.country === 'Denmark') {
                  pipeDef = parseFloat(settings['dk-pipe-diameter-definition']);
                } else if(app.country === 'Sweden') {
                  pipeDef = parseFloat(settings['se-duct-diameter-definition']);
                }

                if(getValue(s.outerDiameter, 'mmToMeters') <= pipeDef) {
                  // uKlasse = thermalMath.calculateUValues('circularDuct', o.sectionResults[i].heatloss, contentTemperature, getValue(s.environmentTemperature,'float'), getValue(s.outerDiameter,'mmToMeters'), 0, 0, s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
                  uKlasse = thermalMath.calculateUValues('circularDuct', o.sectionResults[i].heatloss, getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'), getValue(s.outerDiameter, 'mmToMeters'), 0, 0, s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
                  o.sectionResults[i].uKlasseUnit = 'W/mK';
                } else {
                  // uKlasse = thermalMath.calculateUValues('circularDuct', o.sectionResults[i].heatlossArea, contentTemperature, getValue(s.environmentTemperature,'float'), getValue(s.outerDiameter,'mmToMeters'), 0, 0, s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
                  uKlasse = thermalMath.calculateUValues('circularDuct', o.sectionResults[i].heatlossArea, getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'), getValue(s.outerDiameter, 'mmToMeters'), 0, 0, s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
                  o.sectionResults[i].uKlasseUnit = 'W/m²K';
                }
                o.sectionResults[i].uKlasse = uKlasse[0];
                o.sectionResults[i].uKlasseNorm = uKlasse[1];
              }

              o.sectionResults[i].warnings = {surface: [], object: []};
              if( nominalDensity.findIndex(item => item < 80) !== -1 && s.direction === 'vert' && getValue(s.temperature, 'float') >= 100 ) {
                o.sectionResults[i].warnings.surface.push(
                  ui['WARNING_MATERIAL_DENSITY']
                );
              }
              if( !s.noInsulation && ( o.sectionResults[i].dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][layers.length]) {
                o.sectionResults[i].warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
              }
              if( s.noInsulation && ( o.sectionResults[i].dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][0]) {
                o.sectionResults[i].warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
              }
              if(getValue(material['Maximum-service-temperature'], 'int') <= contentTemperature) {
                o.sectionResults[i].warnings.object.push(ui['INSULATION-OBJECT_MATERIAL_MST_ALERT']);
              }
              if(cladding && getValue(cladding['MST'], 'int') <= heatLossResults[3][layers.length]) {
                o.sectionResults[i].warnings.surface.push(ui['INSULATION-CLADDING_ALERT']);
              }

// RECTANGULAR DUCT
            } else {
              let layers = [];
              let maxTemperatures = [];
              let layerProducts = [];
              let nominalDensity = [];
              let overAllThicknessOfInsulation = 0;
              let lambdas = [ [ getValue(material['Thermal-conductivity'], 'float') ]];
              let thicknesses = [ getValue(s.thickness, 'mmToMeters') ];
              let contentFlowRate = thermalMath.unitConversion(getValue(s.flowRate, 'float'), c.flowRateType, 'rectduct', 0, getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'), getValue(content['Density'], 'int'), getValue(s.thickness, 'mmToMeters'));

              let contentLambda = getValue(content['Thermal-conductivity'], 'float');
              let contentVisc = getValue(content['Kinematic-viscosity'], 'float');
              let contentDensity = getValue(content['Density'], 'float');
              let contentHeatCapasity = getValue(content['Heat-capasity'], 'float');

              const targetDef = {
                type: 'duct',
                actualType: c.type,
                model: 'rectangular',
                direction: s.direction,
                length: parseFloat(s.length),
                width: getValue(s.width, 'mmToMeters'),
                height: getValue(s.height, 'mmToMeters'),
                insThickness: getValue(s.thickness, 'mmToMeters'),
                flowRate: parseFloat(contentFlowRate),
                lambda: contentLambda,
                viscosity: contentVisc,
                density: contentDensity,
                heatCapasity: contentHeatCapasity,
                content: content.Medium,
                insideTemp: contentTemperature,
                claddingSupport: s.supportOfCladding,
                claddingSupportInfluence: getValue(s.influenceOnHeatloss, 'float') * s.spacersPerM,
                mechanicalFasteners: s.mechanicalFastener,
                mechanicalInfluence: getValue(s.mechanicalInfluence, 'float') * s.mechanicalPerM,
                solarRadiation: c.calculateSolarRadiation,
                solarRadiationValue: s.environmentSolarRadiation * getValue(s.emissivity, 'float'),
              };

              for(let j = 0; j < s.insulationLayers.length; j++) {
                layers.push(getItemByNid(s.insulationLayers[s.insulationLayers.length - j - 1].selectedItem, products));
                layers[j].thickness = s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness;
                overAllThicknessOfInsulation += getValue(s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness, 'float');
                lambdas.push([getValue(layers[j].a, 'float'), getValue(layers[j].b, 'float'), getValue(layers[j].c, 'float'), getValue(layers[j].d, 'float')]);
                thicknesses.push(getValue(layers[j].thickness, 'mmToMeters'));

                maxTemperatures.push({mst: getValue(layers[j].MST, 'int'), facing: getValue(layers[j]['Facing-MST'], 'int'), net: getValue(layers[j]['Net-MST'], 'int')});

                nominalDensity.push(getValue(layers[j]['nominal-density'], 'float'));
                if(layers[j].hasOwnProperty('custom') && layers[j].custom === 'true') {
                  layerProducts.push({name: '*' + layers[j]['name'], thickness: s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness});
                } else {
                  layerProducts.push({name: layers[j]['Product-name'], thickness: s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness});
                }
              }


              let uninsulatedHeatLossResults = thermalMath.heatLossIterative('plane', getValue(material.Emissivity, 'float'),
                                      contentTemperature, getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
                                      getValue(s.environmentAirVelocity, 'float'), [getValue(s.thickness, 'mmToMeters')], [0], [0], true, {...targetDef, uninsulated: true});

              let heatLossResults;
              if(s.noInsulation) {
                heatLossResults = uninsulatedHeatLossResults;
              } else {
                heatLossResults = thermalMath.heatLossIterative('plane', getValue(s.emissivity, 'float'),
                                      contentTemperature, getValue(s.environmentTemperature, 'float'),  lambdas,
                                      getValue(s.environmentAirVelocity, 'float'), thicknesses, [0], [0], false, targetDef);
              }

/*               let uninsulatedPipelineHeatLoss = thermalMath.heatLossIterative('plane', getValue(material.Emissivity,'float'),
                                      uninsulatedContentTemperature, getValue(s.environmentTemperature,'float'),  [ getValue(material['Thermal-conductivity'],'float') ],
                                      getValue(s.environmentAirVelocity,'float'), [getValue(s.thickness,'mmToMeters')], [0],[0], true);
 */

              let addToHeatLoss = 0;
              let addToHeatLossUnins = 0;
              if(s.supportOfCladding) {
                addToHeatLoss += getValue(s.influenceOnHeatloss, 'float');
              }
              if(s.suspensionOfTarget) {
                addToHeatLoss += getValue(s.suspensionInfluence, 'float');
                addToHeatLossUnins += getValue(s.suspensionInfluence, 'float');
              }

              let areaOfOneMOfDuct = 1 * ( getValue(s.width, 'mmToMeters') * 2 + getValue(s.height, 'mmToMeters') * 2);
              let areaOfOneMOfInsDuct = 1 * ( (getValue(s.width, 'mmToMeters') + getValue(overAllThicknessOfInsulation, 'mmToMeters') * 2) * 2 + (getValue(s.height, 'mmToMeters') + getValue(overAllThicknessOfInsulation, 'mmToMeters') * 2) * 2);

              // Calculate the heat loss and the temperature drop in sections
              var sliceEndTempIns;
              var sliceEndTempUnIns;
              let sliceFactor = 0.1;
              if(s.length >= 10000) {
                sliceFactor = 10;
              } else if(s.length >= 1000) {
                sliceFactor = 1;
              }
              if(c.calculateTemperatureChange && parseFloat(s.length) > 0 && parseFloat(contentFlowRate) > 0 ) {
                let sliceCount = s.length / sliceFactor;
                let sliceTempIns = contentTemperature;
                let sliceTempUnIns = contentTemperature;
                let sliceHeatlossIns, sliceHeatlossUnIns;
                let originalHeatloss = heatLossResults[2];
                let originalHeatlossUnInsulated = uninsulatedHeatLossResults[2];
                for(let slice = 0; slice < sliceCount; slice++) {
                  sliceHeatlossUnIns = thermalMath.heatLossIterative('plane', getValue(material.Emissivity, 'float'),
                                          sliceTempUnIns, getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
                                          getValue(s.environmentAirVelocity, 'float'), [getValue(s.thickness, 'mmToMeters')], [0], [0], true, {...targetDef, noLog: true});
                  sliceHeatlossIns = thermalMath.heatLossIterative('plane', getValue(s.emissivity, 'float'),
                                          sliceTempIns, getValue(s.environmentTemperature, 'float'),  lambdas,
                                          getValue(s.environmentAirVelocity, 'float'), thicknesses, [0], [0], false, {...targetDef, noLog: true});

                  if(s.noInsulation) {
                    sliceHeatlossIns = sliceHeatlossUnIns;
                  }


                  let sliceTempDropIns;
                  let sliceTempDropUnIns;
                  if(s.supportOfCladding || s.suspensionOfTarget) {
                    sliceTempDropIns = thermalMath.temperatureDropRectDuct( getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(sliceFactor, 'float'),  sliceTempIns,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  (sliceHeatlossIns[2] * areaOfOneMOfInsDuct + (sliceHeatlossIns[2] * areaOfOneMOfInsDuct * addToHeatLoss) / 100 ), getValue(s.thickness, 'mmToMeters'));
                  } else {
                    sliceTempDropIns = thermalMath.temperatureDropRectDuct( getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(sliceFactor, 'float'),  sliceTempIns,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  sliceHeatlossIns[2] * areaOfOneMOfInsDuct, getValue(s.thickness, 'mmToMeters'));
                  }
                  // if(s.suspensionOfTarget) {
                  //   sliceTempDropUnIns = thermalMath.temperatureDropRectDuct( getValue(s.width,'mmToMeters'), getValue(s.height,'mmToMeters'),  contentFlowRate,  getValue(content.Density,'float'),  getValue(0.1,'float'),  sliceTempUnIns,  getValue(s.environmentTemperature,'float'),  getValue(content['Heat-capasity'],'float'),  (sliceHeatlossUnIns[2]*areaOfOneMOfInsDuct + (sliceHeatlossUnIns[2]*areaOfOneMOfInsDuct*addToHeatLossUnins)/100), getValue(s.thickness,'mmToMeters'));
                  // } else {
                    sliceTempDropUnIns = thermalMath.temperatureDropRectDuct( getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(sliceFactor, 'float'),  sliceTempUnIns,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  sliceHeatlossUnIns[2] * areaOfOneMOfInsDuct, getValue(s.thickness, 'mmToMeters'));
                  // }

                  sliceTempIns = sliceTempDropIns;
                  if(s.noInsulation) {
                    sliceTempIns = sliceTempDropUnIns;
                  }
                  sliceTempUnIns = sliceTempDropUnIns;
                }

                heatLossResults[2] = (originalHeatloss + sliceHeatlossIns[2]) / 2;
                uninsulatedHeatLossResults[2] = (originalHeatlossUnInsulated + sliceHeatlossUnIns[2]) / 2;
                sliceEndTempIns = sliceTempIns;
                sliceEndTempUnIns = sliceTempUnIns;
              }

/*               // TESTING temperaturedrop calculation in short sections
              let sliceCount = s.length/0.1;
              let sliceTemp= contentTemperature;
              let sliceHeatloss;
              for(let slice=0;slice<sliceCount;slice++) {
                if(s.noInsulation) {
                  sliceHeatloss = thermalMath.heatLossIterative('plane', getValue(material.Emissivity,'float'),
                                          sliceTemp, getValue(s.environmentTemperature,'float'),  [ getValue(material['Thermal-conductivity'],'float') ],
                                          getValue(s.environmentAirVelocity,'float'), [getValue(s.thickness,'mmToMeters')], [0],[0], true);
                } else {
                  sliceHeatloss = thermalMath.heatLossIterative('plane', getValue(s.emissivity,'float'),
                                          sliceTemp, getValue(s.environmentTemperature,'float'),  lambdas,
                                          getValue(s.environmentAirVelocity,'float'), thicknesses, [0],[0], false);
                }
                let sliceTempDrop = thermalMath.temperatureDropRectDuct( getValue(s.width,'mmToMeters'), getValue(s.height,'mmToMeters'),  contentFlowRate,  getValue(content.Density,'float'),  getValue(0.1,'float'),  sliceTemp,  getValue(s.environmentTemperature,'float'),  getValue(content['Heat-capasity'],'float'),  sliceHeatloss[2], getValue(s.thickness,'mmToMeters'));
                sliceTemp=sliceTempDrop
              }
              console.log( {contentTemperature,endTemperature:sliceTemp,temperatureDrop:(sliceTemp-contentTemperature), heatLossStart:heatLossResults[2], heatLossEnd:sliceHeatloss[2]}) */

              let adapterResults = [];
              let adapterResultsTotal = 0;
              if(s.calculateAdapters) {
                for(let a = 0; a < c.adapters.length; a++) {
                  let adapter = c.adapters[a];
                  let aMaterial = getItemByNid(adapter.Material, materials);

                  let uninsulatedAdapterHeatlossResults = thermalMath.heatLossIterative('plane', getValue(aMaterial.Emissivity, 'float'),
                                      contentTemperature, getValue(s.environmentTemperature, 'float'),  [ getValue(aMaterial['Thermal-conductivity'], 'float') ],
                                      getValue(s.environmentAirVelocity, 'float'), [getValue(adapter['Material-thickness'], 'mmToMeters')], [0], [0], true, {...targetDef, noLog: true});

                  if(getValue(adapter.insCoverage, 'float') > 0) {
                    let aInsulation = getItemByNid('10', products);
                     // Adapter insulation is always PAROC Pro Wired Mat 100, Nid = 10
                    let aLambdas = [];
                    aLambdas.push([ getValue(aMaterial['Thermal-conductivity'], 'float') ]);
                    aLambdas.push( [ getValue(aInsulation.a, 'float'), getValue(aInsulation.b, 'float'), getValue(aInsulation.c, 'float'), getValue(aInsulation.d, 'float') ] );
                    let aThicknesses = [ getValue(adapter.thickness, 'mmToMeters'), getValue(adapter['Material-thickness'], 'mmToMeters') ];

                    let adapterHeatlossResults = thermalMath.heatLossIterative('plane', getValue(adapter.emissivity, 'float'),
                                      contentTemperature, getValue(s.environmentTemperature, 'float'),  aLambdas,
                                      getValue(s.environmentAirVelocity, 'float'), aThicknesses, [0], [0], false, {...targetDef, noLog: true});

                    let adapterHeatloss = uninsulatedAdapterHeatlossResults[2] - (uninsulatedAdapterHeatlossResults[2] - adapterHeatlossResults[2]) * getValue(adapter.insCoverage, 'float') / 100;
                    adapterResults.push( (adapterHeatloss * adapter.Equivalence) );
                    adapterResultsTotal += (adapterHeatloss * adapter.Equivalence);
                  } else {
                    adapterResults.push( (uninsulatedAdapterHeatlossResults[2] * adapter.Equivalence) );
                    adapterResultsTotal += (uninsulatedAdapterHeatlossResults[2] * adapter.Equivalence) * adapter.count;
                  }
                }
              }

              let heatlossPerSqrM = heatLossResults[2];

              if(s.noInsulation) {
                o.sectionResults.push({heatloss: (heatlossPerSqrM * areaOfOneMOfDuct), alphae: heatLossResults[1] });
              } else {
                o.sectionResults.push({heatloss: (heatlossPerSqrM * areaOfOneMOfInsDuct), alphae: heatLossResults[1] });
              }
              o.sectionResults[i].surfaceTemperature = heatLossResults[3][ heatLossResults[3].length - 1 ];
              // o.sectionResults[i].uninsulatedHeatLoss = (uninsulatedHeatLossResults[2] + ( uninsulatedHeatLossResults[2] * addToHeatLossUnins ) / 100) *areaOfOneMOfDuct;
              // o.sectionResults[i].uninsulatedHeatLoss = uninsulatedHeatLossResults[2] * areaOfOneMOfDuct
              o.sectionResults[i].uninsulatedHeatLoss = (uninsulatedHeatLossResults[2] + ( uninsulatedHeatLossResults[2] * addToHeatLossUnins ) / 100) * areaOfOneMOfDuct;
              // o.sectionResults[i].uninsulatedHeatLossArea = uninsulatedHeatLossResults[2]
              o.sectionResults[i].uninsulatedHeatLossArea = uninsulatedHeatLossResults[2] + ( uninsulatedHeatLossResults[2] * addToHeatLossUnins ) / 100;
              // o.sectionResults[i].uninsulatedHeatLossArea = thermalMath.heatlossConvertLengthToArea(uninsulatedHeatLossResults[2], 0, getValue(s.width,'mmToMeters'), getValue(s.height,'mmToMeters') );

              if(s.calculateAdapters) {
                o.sectionResults[i].adapterHeatloss =  adapterResults;
                o.sectionResults[i].adapterHeatlossTotal = adapterResultsTotal;
                totalAdaptersHeatloss += adapterResultsTotal;
              }

              o.sectionResults[i].uninsulatedSurfaceTemperature = uninsulatedHeatLossResults[3][0];
              o.sectionResults[i].dewPoint = thermalMath.dewPoint(getValue(s.environmentTemperature, 'float'), getValue(s.environmentHumidity, 'float'));

              o.sectionResults[i].material = (material.hasOwnProperty('custom') && material.custom) ? material.name : material; // (material[app.language]!==false)?material[app.language]:material['English'];
              o.sectionResults[i].energySource = (energySource.hasOwnProperty('custom') && energySource.custom) ? energySource.name : energySource; // (energySource[app.language]!==false)?energySource[app.language]:energySource['English'];
              o.sectionResults[i].content = (content.hasOwnProperty('custom') && content.custom) ? content.name : content; // (content[app.language]!==false)?content[app.language]:content['English'];
              o.sectionResults[i].alphaR = heatLossResults[4][0];
              o.sectionResults[i].alphaK = heatLossResults[4][1];
              o.sectionResults[i].hSi = heatLossResults[4][2];
              o.sectionResults[i].addition = heatLossResults[4][3];
              o.sectionResults[i].joint = heatLossResults[4][4];

              if(s.cladding == -1) {
                o.sectionResults[i].cladding = ui['GENERAL-OTHER_CLADDING'];
              } else if(s.cladding == -2) {
                o.sectionResults[i].cladding = ui['GENERAL-NO_CLADDING'];
              } else if(cladding && cladding.hasOwnProperty('custom') && cladding.custom) {
                o.sectionResults[i].cladding = cladding.name;
              } else {
                o.sectionResults[i].cladding = cladding; // (cladding[app.language]!==false)?cladding[app.language]:cladding['English'];
              }

              o.sectionResults[i].nominalWeight = thermalMath.calculateInsulationWeight('duct', 0, 0, 1, thicknesses, getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'), nominalDensity);

              o.sectionResults[i].layers = [];
    //          console.log('heatLossResults: ',heatLossResults)
              for(let j = 0; j < layers.length; j++) {
                o.sectionResults[i].layers.push( { 'surfaceTemperature': heatLossResults[3][j + 1], 'thermalConductivity': heatLossResults[0][j] } );
                o.sectionResults[i].layers[j].warnings = [];
                o.sectionResults[i].layers[j].product = layerProducts[j];
                if(maxTemperatures[j].mst <= heatLossResults[3][j]) {
                  o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-MATERIAL_MST_ALERT']);
                }
                if(maxTemperatures[j].facing <= heatLossResults[3][j + 1] && maxTemperatures[j].facing !== NaN) {
                  o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-FACING_MST_ALERT']);
                }
                if(maxTemperatures[j].net <= heatLossResults[3][j + 1] && maxTemperatures[j].net !== NaN) {
                  o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-NET_MST_ALERT']);
                }
              }

              if(s.noInsulation) {
                // o.sectionResults[i].heatloss = o.sectionResults[i].heatloss + ( o.sectionResults[i].heatloss * addToHeatLossUnins ) / 100;
                // o.sectionResults[i].heatloss = o.sectionResults[i].heatloss
                o.sectionResults[i].heatloss = o.sectionResults[i].uninsulatedHeatLoss;
                o.sectionResults[i].heatlossArea = o.sectionResults[i].uninsulatedHeatLossArea; // heatlossPerSqrM + ( heatlossPerSqrM * addToHeatLossUnins ) / 100
                // o.sectionResults[i].heatlossArea = thermalMath.heatlossConvertLengthToArea(o.sectionResults[i].heatloss, 0, getValue(s.width,'mmToMeters'), getValue(s.height,'mmToMeters') );
              } else {
                o.sectionResults[i].heatloss = o.sectionResults[i].heatloss + ( o.sectionResults[i].heatloss * addToHeatLoss ) / 100;
                o.sectionResults[i].heatlossArea = heatlossPerSqrM + ( heatlossPerSqrM * addToHeatLoss ) / 100;
                // o.sectionResults[i].heatlossArea = thermalMath.heatlossConvertLengthToArea(o.sectionResults[i].heatloss, 0, (getValue(s.width,'mmToMeters') + getValue(overAllThicknessOfInsulation,'mmToMeters') * 2), (getValue(s.height,'mmToMeters') + getValue(overAllThicknessOfInsulation,'mmToMeters') * 2));
              }

              let rectDuctPerimeter = 2 * getValue(s.height, 'mmToMeters') + 2 * getValue(s.width, 'mmToMeters');
              o.sectionResults[i].coEmissionReduction = Math.abs( getValue( (thermalMath.emissionCO2('pipe', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, o.sectionResults[i].uninsulatedHeatLoss, 0, 0, getValue(s.length, 'float')) - thermalMath.emissionCO2('pipe', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, o.sectionResults[i].heatloss, 0, 0, getValue(s.length, 'float') ) ), 'gToKg') );
              o.sectionResults[i].annualSavingsKwh = Math.abs( getValue( (thermalMath.annualCostKwh('pipe', o.sectionResults[i].uninsulatedHeatLoss, c.energyOperationTime, 0, 0, getValue(s.length, 'float')) - thermalMath.annualCostKwh('pipe', o.sectionResults[i].heatloss, c.energyOperationTime, 0, 0, getValue(s.length, 'float')) ), 'wToKwh') );
              o.sectionResults[i].annualSavings = Math.abs( getValue( (thermalMath.annualCost('pipe', o.sectionResults[i].uninsulatedHeatLoss, c.energyPrice, c.energyOperationTime, 0, 0, getValue(s.length, 'float')) - thermalMath.annualCost('pipe', o.sectionResults[i].heatloss, c.energyPrice, c.energyOperationTime, 0, 0, getValue(s.length, 'float')) ), 'cToE') );

              let temperatureAtTheSectionEnd;
              let uninsulatedTemperatureAtTheSectionEnd;
              if(c.calculateTemperatureChange) {
                temperatureAtTheSectionEnd = sliceEndTempIns;
                uninsulatedTemperatureAtTheSectionEnd = sliceEndTempUnIns;
              } else {
                temperatureAtTheSectionEnd = thermalMath.temperatureDropRectDuct( getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(s.length, 'float'),  contentTemperature,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  o.sectionResults[i].heatloss, getValue(s.thickness, 'mmToMeters'));
                uninsulatedTemperatureAtTheSectionEnd = thermalMath.temperatureDropRectDuct( getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'),  contentFlowRate,  getValue(content.Density, 'float'),  getValue(s.length, 'float'),  uninsulatedContentTemperature,  getValue(s.environmentTemperature, 'float'),  getValue(content['Heat-capasity'], 'float'),  uninsulatedHeatLossResults[2], getValue(s.thickness, 'mmToMeters'));
              }
              o.sectionResults[i].temperatureDrop = temperatureAtTheSectionEnd - contentTemperature;

              o.sectionResults[i].coolingTime = '-';
              o.sectionResults[i].totalSectionHeatloss = o.sectionResults[i].heatloss * getValue(s.length, 'float');
              contentTemperature = temperatureAtTheSectionEnd;
              uninsulatedContentTemperature = uninsulatedTemperatureAtTheSectionEnd;
              totalPipelineHeatLoss += o.sectionResults[i].heatloss * getValue(s.length, 'float');
              totalUninsulatedPipelineHeatLoss += o.sectionResults[i].uninsulatedHeatLoss * getValue(s.length, 'float');

              if(app.country === 'Denmark' || app.country === 'Sweden' || (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) {
                  // calculateUValues(targetType, heatLoss, mediumTemp, outsideTemp, pipeDiameter, rectDuctWidth, rectDuctHeight, klasse:Object)
/*                let uKlasse
                 if( ( (2 * getValue(s.width,'mmToMeters') + 2 * getValue(s.height,'mmToMeters')) / Math.PI ) <= 0.4) {
                  uKlasse = thermalMath.calculateUValues('rectangularDuct', o.sectionResults[i].heatloss, contentTemperature, s.environmentTemperature, 0, getValue(s.width,'mmToMeters'), getValue(s.height,'mmToMeters'), s.klasse, settings,(settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1));
                  o.sectionResults[i].uKlasseUnit = 'W/mK';
                } else { */
                // let uKlasse = thermalMath.calculateUValues('rectangularDuct', o.sectionResults[i].heatlossArea, contentTemperature, getValue(s.environmentTemperature,'float'), 0, getValue(s.width,'mmToMeters'), getValue(s.height,'mmToMeters'), s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
                let uKlasse = thermalMath.calculateUValues('rectangularDuct', o.sectionResults[i].heatlossArea, getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'), 0, getValue(s.width, 'mmToMeters'), getValue(s.height, 'mmToMeters'), s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
                o.sectionResults[i].uKlasseUnit = 'W/m²K';
                // }
                o.sectionResults[i].uKlasse = uKlasse[0];
                o.sectionResults[i].uKlasseNorm = uKlasse[1];
              }

              o.sectionResults[i].warnings = {surface: [], object: []};
              if( nominalDensity.findIndex(item => item < 80) !== -1 && s.direction === 'vert' && getValue(s.temperature, 'float') >= 100 ) {
                o.sectionResults[i].layers[layers.length - 1].warnings.push(
                  ui['WARNING_MATERIAL_DENSITY']
                );
              }
              if( !s.noInsulation && ( o.sectionResults[i].dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][layers.length]) {
                o.sectionResults[i].warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
              }
              if( s.noInsulation && ( o.sectionResults[i].dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][0]) {
                o.sectionResults[i].warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
              }
              if(getValue(material['Maximum-service-temperature'], 'int') <= contentTemperature) {
                o.sectionResults[i].warnings.object.push(ui['INSULATION-OBJECT_MATERIAL_MST_ALERT']);
              }
              if(cladding && getValue(cladding['MST'], 'int') <= heatLossResults[3][layers.length]) {
                o.sectionResults[i].warnings.surface.push(ui['INSULATION-CLADDING_ALERT']);
              }
            }

          /*
          console.log('totalPipelineHeatLoss: ',totalPipelineHeatLoss);
          console.log('totalUninsulatedPipelineHeatLoss: ',totalUninsulatedPipelineHeatLoss);
          console.log('duct results: ',o);
          */
          }

          o.finalPipelineTemperature = contentTemperature;
          o.totalPipelineHeatLoss = totalPipelineHeatLoss;
          o.totalUninsulatedPipelineHeatLoss = totalUninsulatedPipelineHeatLoss;
          o.totalAdaptersHeatloss = totalAdaptersHeatloss;
          o.totalAnnualSavingsKwh = 0;
          o.totalAnnualSavings = 0;
          o.totalCOemissionReduction = 0;
          for(let i = 0; i < c.sections.length; i++)  {
            o.totalAnnualSavingsKwh += o.sectionResults[i].annualSavingsKwh;
            o.totalAnnualSavings += o.sectionResults[i].annualSavings;
            o.totalCOemissionReduction += o.sectionResults[i].coEmissionReduction;
          }

          // var t1 = performance.now();
          // console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.");


          // PIPE
          // o.freezingStartInHours
          // o.frozenToValue
          // o.temperatureChange
          // o.totalHeatLoss
          // o.uninsulatedTotalHeatLoss
          // 0.timeToFinalTemperature


          store.dispatch(updateResults(o));
        } else {
          next(action);
        }

        break;


      default:
        next(action);
    }
  };
}
